import { useState, useMemo } from 'react';
import { Box, styled, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Overview from '../Components/Overview';
import OnDemand from '../Components/OnDemand';
import PPMComponent from '../Components/PPMComponent';
import EnquiryDashboard from '../Components/EnquiryDashboard/EnquiryDashboard';
import AccountingDash from '../Components/DashboardAllGraph/AccountingDash';
import DashTicket from '../Components/Masters/Complaint/Dashboard/DashTicket';
import { usePermissions } from '../GlobalFunction/userPermissions';

const Dashboard = () => {
  const StyledTabs = styled(Tabs)({
    backgroundColor: '#e1e7ef',
    borderRadius: '10px',
    padding: '4px',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  });

  const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    minHeight: '36px',
    padding: '8px 16px',
    borderRadius: '5px',
    color: theme.palette.text.secondary,
    '&.Mui-selected': {
      color: '#fff',
      backgroundColor: '#635bff',
    },
  }));

  // Permissions for different sections
  const OccupancyPermissions = usePermissions("Occupancy-DashBoard");
  const enquiryPermissions = usePermissions("Enquiry-Dash");
  const accountPermissions = usePermissions("Account-Dash");
  const ticketPermissions = usePermissions("Ticket-Dash");

  const { ViewRec: viewOccup = "0" } = OccupancyPermissions || {};
  const { ViewRec: viewEnquiry = "0" } = enquiryPermissions || {};
  const { ViewRec: viewAccount = "0" } = accountPermissions || {};
  const { ViewRec: viewTicket = "0" } = ticketPermissions || {};

 
  const availableTabs = useMemo(() => {
    const tabs = [];
    if (viewOccup === "1") tabs.push({ label: "Occupancy", component: <Overview /> });
    if (viewEnquiry === "1") tabs.push({ label: "Enquiry", component: <EnquiryDashboard /> });
    if (viewTicket === "1") tabs.push({ label: "Ticket", component: <DashTicket /> });
    if (viewAccount === "1") tabs.push({ label: "Account", component: <AccountingDash /> });
    return tabs;
  }, [viewOccup, viewEnquiry, viewTicket, viewAccount]);

  const savedTab = parseInt(localStorage.getItem('dashboardSelectedTab'), 10);
  const [value, setValue] = useState(() => {
    if (!isNaN(savedTab) && savedTab < availableTabs.length) {
      return savedTab;
    }
    return 0;
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem('dashboardSelectedTab', newValue);
  };


  if (availableTabs.length === 0) {
    return (
      <Box sx={{ width: '100%', p: 2 }}>
        <Typography>No dashboard components available</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', p: 2, '& .MuiTabs-root': { padding: '7px 4px 0px 4px !important' } }}>
      <Box sx={{ mb: 4 }}>
        <StyledTabs value={value} onChange={handleChange}>
          {availableTabs.map((tab, index) => (
            <StyledTab key={index} label={tab.label} />
          ))}
        </StyledTabs>
      </Box>
      <Box>
        {availableTabs[value] && availableTabs[value].component}
      </Box>
    </Box>
  );
};

export default Dashboard;